// src/pages/Home.js
import React from "react";
import "../styles/css/style.css";
import "../styles/css/bootstrap.min.css";
import Header from "../components/Header";
import ContactHeader_Form from "../components/ContactHeader_Form";
import ContactDetailsSection from "../components/ContactDetailsSection";
import Footer from "../components/Footer";



const Home = () => {

  return (
    <>
      <Header/>
      <ContactHeader_Form/>
      <ContactDetailsSection/>
      <Footer />

    </>
  );
};

export default Home;
